module.exports = __webpack_public_path__ + "9c0626c1356f1bf74e33e7d8fce2095b.pdf";